import { ReactNode } from 'react'

interface CapabilityTagProps {
  children: ReactNode
}

export function CapabilityTag({ children }: CapabilityTagProps) {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded border border-neutral-200 t-xs text-secondary whitespace-nowrap">
      {children}
    </span>
  )
}
